import script from "./AppointmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentModal.vue?vue&type=script&setup=true&lang=js"

import "./AppointmentModal.vue?vue&type=style&index=0&id=fdf7fcc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdf7fcc2"]])

export default __exports__